import { apiPlugin, storyblokInit } from "gatsby-source-storyblok";

export const initStoryblokApi = (bridge: boolean) =>
	storyblokInit({
		accessToken: process.env.GATSBY_STORYBLOK_TOKEN,
		bridge,
		use: [apiPlugin],
		apiOptions: {
			accessToken: process.env.GATSBY_STORYBLOK_TOKEN,
			cache: {
				clear: "auto",
				type: "memory",
			},
		},
	});
